import { Select } from 'components/Form/Select';
import { useUsers } from 'hooks/fetch/useUsers';
import { useFormContext } from 'react-hook-form';
import { InputGroup } from 'styles/InputGroup';

export function UserId() {
    const { control } = useFormContext();

    const { query: { data, isLoading } } = useUsers('/users');

    return (
        <InputGroup>
            <Select
                name="user_id"
                control={control}
                label="Usuário"
                placeholder="Opcional"
                fullwidth
                config={{
                    noOptionsMessage: () => 'Nenhum usuário encontrado.',
                    options: data?.pages?.[0].data ? data?.pages?.[0].data.map((user) => ({ value: user.id, label: user.name })) : [],
                    closeMenuOnSelect: true,
                    isDisabled: isLoading,
                }}
                required
            />
        </InputGroup>
    );
}
